import React from "react";
import SSOContainer from "../shared/containers/SSOContainer";
import styles from "../../assets/css/modules/myprofile/add-a-plan-from-no-access.css";
import AddAPlan from "./AddAPlan";
import AddAPlanMfa from "./AddAPlanMfa";
import SSOContainerMfa from "../shared/containers/SSOContainerMfa";


export function AddAPlanFromNoAccess() {


    return (
 window?.axa?.features?.MFAFeature === "true"?
 <SSOContainerMfa>
      <div className={styles.addAPlanFromNoAccess}>
        <AddAPlanMfa />
      </div>
    </SSOContainerMfa>
   :
         <SSOContainer>
      <div className={styles.addAPlanFromNoAccess}>
        <AddAPlan />
      </div>
    </SSOContainer>

  );


}

export default AddAPlanFromNoAccess;
